/**
 * @generated SignedSource<<ced7554681481c63bd4bd3c2c9c47fb8>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type SyncToAsanaInput = {
  clientMutationId?: string | null;
};
export type AsanaIntegrationSyncMutation$variables = {
  input: SyncToAsanaInput;
};
export type AsanaIntegrationSyncMutation$data = {
  readonly syncToAsana: {
    readonly asyncResultId: any | null;
    readonly ok: boolean;
  } | null;
};
export type AsanaIntegrationSyncMutation = {
  response: AsanaIntegrationSyncMutation$data;
  variables: AsanaIntegrationSyncMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "SyncToAsanaPayload",
    "kind": "LinkedField",
    "name": "syncToAsana",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "ok",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "asyncResultId",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "AsanaIntegrationSyncMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "AsanaIntegrationSyncMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "c4c3fe0fd9ba38a672cc1a71509ea8ee",
    "id": null,
    "metadata": {},
    "name": "AsanaIntegrationSyncMutation",
    "operationKind": "mutation",
    "text": "mutation AsanaIntegrationSyncMutation(\n  $input: SyncToAsanaInput!\n) {\n  syncToAsana(input: $input) {\n    ok\n    asyncResultId\n  }\n}\n"
  }
};
})();

(node as any).hash = "cbbb173b27bb3782b3b2e265497ebfa2";

export default node;
